import waitFor from 'src/config/setup/plugins/waitFor/index.js'
import can from 'src/config/setup/plugins/can/index.ts'
export default function registerSduiPlugins(app) {
  app.use(waitFor)
  app.use(can)
}
